<template>
  <div id="events-calendar-app">
    <v-calendar
      :attributes='attrs'
      :min-date="fromDate"
      :max-date="toDate"
      color="orange" @dayclick="handleDayClick">
    </v-calendar>
  </div>
</template>

<script>
/* global EVENTS_URI */

import moment from 'moment'

export default {
  name: 'App',
  data() {
    return {
      events: [],
      fromDate: moment().startOf('month').valueOf(),
      toDate: moment().endOf('month').add('2', 'days').endOf('month').valueOf()
    };
  },
  computed: {
    attrs() {
      return [
        // Attributes for events
        ...this.events.map(item => ({
          dates: moment(item.starts).toDate(),
          dot: {
            color: 'blue'
          },
          popover: {
            label: item.title,
          },
          customData: item,
        })),
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        }
      ];
    },
  },
  methods: {
    handleDayClick (day) {
      if (day.attributes.length > 0) {
        if (day.attributes.length === 1) {
          console.log(day.attributes[0].customData.description)
          window.dispatchEvent(new CustomEvent("dayClick", { detail: day.attributes[0].customData }))
        } else {
          let payload = {
            day: day.day,
            month: day.month,
            year: day.year
          }
          let url = new URL(window.location.protocol + "//" + window.location.host + EVENTS_URI)
          url.search = new URLSearchParams(payload)
          window.location = url.toString()
          console.log("Multiple events on the same day")
        }
      }
    }
  },
  async created() {
    let httpResponse = await fetch('/api/v1/events/calendar/')
    let response = await httpResponse.json()
    this.events = response.data
  }
};
</script>

<style>
</style>
